import { render, staticRenderFns } from "./CompanyRoles.vue?vue&type=template&id=416d1e64&scoped=true"
import script from "./CompanyRoles.vue?vue&type=script&lang=js"
export * from "./CompanyRoles.vue?vue&type=script&lang=js"
import style0 from "./CompanyRoles.vue?vue&type=style&index=0&id=416d1e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416d1e64",
  null
  
)

export default component.exports